import { render } from "./articleDetail.vue?vue&type=template&id=3ddcc1a5&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=3ddcc1a5&lang=scss&scoped=true"
import "./articleDetail.vue?vue&type=style&index=1&id=3ddcc1a5&lang=scss"

import exportComponent from "F:\\Code3\\medical-website---web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_0e94901392e05a49343df8105549c0e4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddcc1a5"]])

export default __exports__